import type { RaRecord } from 'react-admin';
import { Box, Chip, Stack } from '@mui/material';
import { PillButtonField } from '@/components/fields';
import { COUNTRY_CODE_TO_FLAG } from '@/constants';
import { PROFILE_STATUS_COLOR_MAP, PROFILE_STATUS_VALUE_MAP } from '@/pages/Candidate/constants';
import CopyToClipboard from '@/pages/components/CopyToClipboard';
import { formatApplicantSourceBadgeDisplay } from '@/pages/utils';
import { CardContentStyled, CardStyled, HeaderChip, HeaderChipSecondaryAccent, WorkerName } from './styled';
import { getManualBackgroundCheck } from './utils';

const CandidateOverview = ({ record }: { record: RaRecord }) => {
  return (
    <CardStyled variant="outlined">
      <CardContentStyled>
        <Stack direction="row" justifyContent="space-between" spacing={1.25}>
          <Stack direction="column" alignItems="flex-start" spacing={2}>
            <Box sx={{ minWidth: 0 }}>
              <Stack direction="row" alignItems="center" flexWrap="wrap" spacing={1} useFlexGap>
                <WorkerName variant="h5" component="div">
                  <CopyToClipboard label="Name" value={record.display_name}>
                    <span>{record.display_name}</span>
                  </CopyToClipboard>
                  {record?.package?.country_code ? (
                    <span>{COUNTRY_CODE_TO_FLAG?.[record.package.country_code]}</span>
                  ) : null}
                </WorkerName>
              </Stack>
            </Box>

            <Stack direction="row" spacing={1} useFlexGap>
              {getManualBackgroundCheck(record.is_manual_background_check) ? (
                <Chip
                  label="Manual"
                  size="medium"
                  sx={(theme) => ({
                    bgcolor: theme.palette.turn_violet.main,
                    color: theme.palette.error.contrastText,
                    fontWeight: 600,
                    border: 'none',
                    '& .MuiChip-label': { px: 1.25 },
                  })}
                />
              ) : null}

              <PillButtonField
                source="profile_status"
                valueMap={PROFILE_STATUS_VALUE_MAP}
                colorMap={PROFILE_STATUS_COLOR_MAP}
              />

              <CopyToClipboard label="ID" value={record.id.toString()}>
                <HeaderChip variant="outlined" label={`ID: ${record.id}`} />
              </CopyToClipboard>

              <CopyToClipboard label="Turn ID" value={record.turn_id}>
                <HeaderChip variant="outlined" label={`Turn ID: ${record.turn_id}`} />
              </CopyToClipboard>

              {record.source ? (
                <CopyToClipboard label="Applicant Source" value={record.source}>
                  <HeaderChipSecondaryAccent
                    label={`Applicant Source: ${formatApplicantSourceBadgeDisplay(record.source)}`}
                  />
                </CopyToClipboard>
              ) : null}

              {record.reference_id ? (
                <CopyToClipboard label="Reference ID" value={record.reference_id}>
                  <HeaderChip variant="outlined" label={`Reference ID: ${record.reference_id}`} />
                </CopyToClipboard>
              ) : null}
            </Stack>
          </Stack>
        </Stack>
      </CardContentStyled>
    </CardStyled>
  );
};

export default CandidateOverview;
